import { render, staticRenderFns } from "./auth_google.vue?vue&type=template&id=21cc8ab2&scoped=true"
import script from "./auth_google.vue?vue&type=script&lang=js"
export * from "./auth_google.vue?vue&type=script&lang=js"
import style0 from "./auth_google.vue?vue&type=style&index=0&id=21cc8ab2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cc8ab2",
  null
  
)

export default component.exports